import React from "react";
import { useSelector } from "react-redux";
import { getFirstChar, renderMonth } from "../../../../../helpers/common";

const Certifications = ({ handleOpenModal, componentType = "overview" }) => {
  const { certifications } = useSelector((state) => state.customer);

  const getValidity = (item) => {
    // FIX: Dono keys check karo (Naya vs Purana)
    const af = item?.additionalFields || item?.additional_fields;
    
    const issueMonth = af?.issue_month;
    const issueYear = af?.issue_year;

    const expirationMonth = af?.expiration_month;
    const expirationYear = af?.expiration_year;

    if (!expirationMonth) {
      return `Validity from: ${renderMonth(
        issueMonth
      )} ${issueYear}. Does not expire`;
    }

    return `Validity: (${renderMonth(issueMonth)} ${issueYear} - ${renderMonth(
      expirationMonth
    )} ${expirationYear})`;
  };

  if (!certifications?.length) {
    return <p className="mt-4 mb-5">No certification has been added.</p>;
  }

  return (
    <>
      {certifications?.map((item) => {
        // ✅ FIX: Get the correct additional fields object
        const af = item?.additionalFields || item?.additional_fields;

        return (
          <div
            key={item?.id}
            className="candidate-education-content mt-4 d-flex"
          >
            <div className="circle flex-shrink-0 bg-soft-primary">
              {/* ✅ Use 'af' instead of hardcoded underscore key */}
              {getFirstChar(af?.title)}
            </div>
            <div className="ms-4">
              <div className="d-flex">
                <div>
                  <h6 className="fs-16 mb-0 me-3">
                    {af?.title}
                  </h6>

                  {af?.organization && (
                    <span className="me-2">
                      {af?.organization}
                    </span>
                  )}

                  {af?.url && (
                    <a
                      href={af?.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="uil uil-external-link-alt"></i>
                    </a>
                  )}
                </div>

                {componentType === "update" ? (
                  <div
                    className="cursor-pointer"
                    onClick={() => handleOpenModal("update", item)}
                  >
                    <i className="uil uil-edit"></i>
                  </div>
                ) : null}
              </div>
              <p className="mb-2 text-muted">{getValidity(item)}</p>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Certifications;
